import { render } from "./BatchCreatePlayer.vue?vue&type=template&id=0eed4958&scoped=true"
import script from "./BatchCreatePlayer.vue?vue&type=script&lang=js"
export * from "./BatchCreatePlayer.vue?vue&type=script&lang=js"

import "./BatchCreatePlayer.vue?vue&type=style&index=0&id=0eed4958&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eed4958"]])

export default __exports__